<template>
  <div>
    <layout-header title="Trámite IRE" subtitle="Información Reservada anual de las ESI">
      <ets-button v-if="isAllowed" icon="add" @click="generateReport" />
    </layout-header>
    <ets-page>
      <template v-if="isAllowed">
        <ets-alert type="info">Presentar antes de: 28 de Febrero</ets-alert>
        <download-section ref="downloadSection" procedure="ire" />
        <!-- <div v-if="!existLastProcedure" class="comments">
          El fichero del año actual no será definitivo hasta terminar el año. Los datos mostrados son provisionales.
        </div> -->
      </template>
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import Forbidden from "@/components/Forbidden";
import DownloadSection from "@/components/Download/DownloadSection";

export default {
  name: "PageIRE",
  components: {
    LayoutHeader,
    Forbidden,
    DownloadSection
  },
  data: () => ({
    // El último año es por defecto el año anterior del actual
    lastYear: dayjs()
      .subtract(1, "year")
      .year(),
    // Según compliance se debe conservar un histórico de documentos de 10 años
    initialYear: dayjs()
      .subtract(10, "year")
      .year(),
    years: [],
    loadingYear: null,
    message: null
  }),
  computed: {
    ...mapState(["userPermissions"]),
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_E_ProcedureIRE;
    }
  },
  methods: {
    generateReport() {
      this.$refs.downloadSection.initGenerationNewFile();
    }
  }
};
</script>

<style lang="scss" scoped>
.comments {
  font-size: 1rem;
  color: #a9a9a9;
  text-align: left;
  margin: 2rem;
  position: fixed;
  bottom: 2rem;
}
</style>
